/** Strip non-digits; cap at 5 + 4 for ZIP+4 display (12345-6789). */
export function sanitizeUsZipInput(raw: string): string {
  const digits = raw.replace(/\D/g, "").slice(0, 9);
  if (digits.length <= 5) return digits;
  return `${digits.slice(0, 5)}-${digits.slice(5)}`;
}

/** US ZIP: 5 digits, or ZIP+4 (12345-6789). */
export function isValidUsZipCode(value: string): boolean {
  const t = value.trim();
  return /^\d{5}$/.test(t) || /^\d{5}-\d{4}$/.test(t);
}

/**
 * First 5 digits of a US postal code for APIs that only accept ZIP5
 * (e.g. Zippopotam returns 404 for `12345-6789` paths).
 */
export function usZip5Base(value: string | number | null | undefined): string {
  const digits = String(value ?? "").replace(/\D/g, "");
  return digits.length >= 5 ? digits.slice(0, 5) : "";
}
